module.exports = __webpack_public_path__ + "static/media/login.199d5b8f.png";